import React, { useEffect, useContext, memo } from 'react';
import getComponent from 'components/FORM_MAP';
import { trackWizardView } from 'utils/trackingFunctions';
import GlobalContext from 'hooks/contexts/GlobalContext';
import { initTrustedForm, initJornaya } from 'utils/thirdPartyScripts';
import { Questionnaire as QuestionnaireType } from 'types';

// Uncontrolled: Jornaya writes the token onto this input via the DOM.
// A controlled value="" would reset it on React re-renders and can trigger
// repeated LeadID token/snap activity.
// eslint-disable-next-line react/display-name
const LeadIdField = memo(() => (
  <input id="leadid_token" name="universal_leadid" type="hidden" defaultValue="" />
));

export default function Questionnaire(
  props: QuestionnaireType
): React.JSX.Element | null {
  const {
    windowSize: { currentBreakpoint },
    sessionInfo: { pageViewId },
    env: { jornayaCampaignId },
  } = useContext(GlobalContext);

  const {
    component,
    mobileComponent,
    isFullPage = false,
    disableTrustedForm,
    ...questionnaireData
  } = props;

  const formComponent =
    currentBreakpoint === 'desktop' ? component : mobileComponent;

  const Form = getComponent(formComponent);

  useEffect(() => {
    if (!disableTrustedForm) {
      initTrustedForm();
    }

    initJornaya(jornayaCampaignId);
    // Intentionally mount-only: both inits are idempotent / once-per-page.
    // Re-running on prop identity changes would re-inject TrustedForm scripts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pageViewId) {
      trackWizardView(props.schoolCode, questionnaireData.variant);
    }
  }, [questionnaireData.variant, pageViewId]);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
  };

  return (
    <form className="questionnaire" onSubmit={onSubmit}>
      <Form {...questionnaireData} isFullPage={isFullPage} />
      <LeadIdField />
    </form>
  );
}
